<template>
	<div class="bg-[#F6F8FA]">
		<Header :current="0"></Header>
		<div class="2xl:max-w-7xl xl:max-w-7xl  mx-auto mb-[100px] py-[16px]  box-border">
			<div class="flex items-center text-[18px] mb-[27px]">
				<label class="cursor-pointer mr-[5px]" @click="goIndex()">{{langInfo.head_home_nav}}</label> <label
					class=" mr-[5px]">></label>
				<label class="cursor-pointer mr-[5px]" @click="goQAZone()">{{langInfo.QA_Zone}}</label><label
					class=" mr-[5px] ml-[5px]">></label><label
					class="w-[150px] text-[#adadad] yw-text-cut-1">{{newDetail.title}}</label>
			</div>
			<div class="pb-[19px] box-border bB-01">
				<div class="text-[36px] text-[#101010] text-center font-bold mb-[20px]">
					{{newDetail.title}}
				</div>
				<!-- is_l1 点赞    is_l2 收藏-->
				<div class="flex items-center justify-center">
					<img src="@/static/image/icon61.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
					<label class="text-[13px] mr-[17px] text-[#686C73]">{{newDetail.create_time}}</label>
					<!-- 	<img src="@/static/image/icon62.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
					<label class="text-[13px] mr-[10px] text-[#686C73]">{{newDetail.number_views}}/次</label>
					<div class="flex items-center" @click="newsResourceLikeClick(2)">
						<img :src="newDetail.is_l2==1?collectActive:collectImg" class="w-[20px] h-[20px] mr-[4px]"
							alt="" />
						<label class="text-[13px] mr-[16px] text-[#686C73]">{{newDetail.is_l2==1?'已收藏':'收藏'}}</label>
					</div>
					<div class="flex items-center" @click="newsResourceLikeClick(1)">
						<img :src="newDetail.is_l1==1?zanActive:zanImg" class="w-[18px] h-[18px] mr-[4px]" alt="" />
						<label class="text-[13px] mr-[16px] text-[#686C73]">{{newDetail.number_likes}}</label>
					</div>
					<img src="@/static/image/icon63.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
					<label class="text-[13px] text-[#686C73]">分享</label> -->
				</div>
			</div>
			<div class="py-[20px] box-border mb-[30px]">
				<div class="" v-html="newDetail.content">
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				id: '',
				isFinish: false,
				newDetail: {
					title: '',
					content: '',
					create_time: '',
					number_likes: 0,
					number_views: 0,
					is_l2: 0,
					is_l1: 0
				},
				filesList: [],
				is_collect: 1,
				collectActive: require('@/static/image/icon65.png'),
				collectImg: require('@/static/image/icon64.png'),

				zanActive: require('@/static/image/icon71.png'),
				zanImg: require('@/static/image/icon70.png'),

				textarea: '',
				langInfo: {},

			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				if (to.query.id) {
					this.id = to.query.id
					this.get_community_detail()
				}
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.get_community_detail()
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			goIndex() {
				this.$router.replace({ path: '/' });
			},
			goQAZone() {
				this.$router.replace({ path: '/QAZone' });
			},
			get_community_detail() {
				this.$api.community_detail({
					id: this.id
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.newDetail = res.data
					
					document.title=this.newDetail.title
					
					this.newDetail.content =  res.data.content.replace(/<img/g,
						"<img style='width:100%;height:auto;'")
					
					this.filesList = res.data.files_attachment
				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			// 收藏
			newsResourceLikeClick(type) {
				this.$api.news_resource_like({
					fid: this.id,
					type: 1, //1=资讯,2=资源
					is_l: type //1=点赞,2=收藏
				}).then((res) => {
					console.log(res);
					this.$message({
						message: res.msg,
						type: 'success'
					})
					this.get_news_detail()
				}).catch((error) => {

					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			downloadClick(item, index) {
				window.open(item.url, '_blank')

			},
			
		}
	}
</script>

<style scoped>
	.banner {
		height: 263px;
		background: linear-gradient(180deg, rgba(110, 175, 247, 1) 0%, rgba(112, 176, 247, 0.64) 0%, rgba(120, 179, 248, 0.11) 34%, rgba(255, 255, 255, 0.11) 100%);
	}

	.navTitle.active::after {
		content: "";
		position: absolute;
		width: 30px;
		height: 4px;
		background-color: #FF0000;
		bottom: -16px;
		left: 50%;
		transform: translateX(-50%);

	}

	::-webkit-scrollbar {
		display: none;
	}

	/deep/.el-textarea__inner {
		background-color: #F2F3F6;
	}
</style>